import { createSelector } from 'reselect';

import { getFilterParamsAdapter, getTimeFilterParams } from './../../api-adapter';
import { getInterval, formatDuration } from '../../util';

const filters = (store) => store.apps.analytics.filters;
const activityStore = (store) => store.apps.analytics.activity;
const userStore = (store) => store.user;
const ownersStore = (store) => store.apps.analytics.owners;
const generalStore = (store) => store.apps.analytics.generalReducer;

export const activitySelector = createSelector([
  filters,
  activityStore,
  generalStore,
], (filteredFilters, activity, general) => {
  const includeStartDay = filteredFilters.getIn(['selectedDateFilter', 'type']) === 'absolute';

  return {
    loading: general.get('loading'),
    filters: filteredFilters.get('filters'),
    selectedDateFilter: filteredFilters.get('selectedDateFilter'),
    selectedDays: formatDuration(filteredFilters.get('selectedDateFilter'), includeStartDay),
    loadingActivity: activity.get('loading'),
    loadingUsersActivity: activity.get('loadingUsersActivity'),
    activity: activity.get('activity'),
  };
});

export const activityParamsSelector = createSelector([
  filters,
  userStore,
  ownersStore,
  (store, options = {}) => options,
], (filtersStore, user, owners, options) => {
  const timeParam = getTimeFilterParams(filtersStore.get('selectedDateFilter'), options.base);

  return {
    ...getFilterParamsAdapter(filtersStore.get('filters')),
    ...timeParam,
    user,
    owners: owners.get('owners'),
    interval: getInterval(timeParam.end - timeParam.start),
    dateFilterType: filtersStore.getIn(['selectedDateFilter', 'type']),
  };
});

export default activitySelector;
